import { MAX_FILE_SIZE } from '../../..';
import { basicValidation } from '../basicValidation';

export const fileValidation = {
    validateFile: (file: {name:string, size:number}, overrideMaxSizeInBytes?: number) => {
        if (file === null || file === undefined)
            return { isSuccess: false, errorMessage: 'file_missing' };
        if(!fileFieldValidation.fileRecord.publicFileName(file.name))
            return { isSuccess: false, errorMessage: 'invalid_file_name' };
        if(file.size > (overrideMaxSizeInBytes ?? MAX_FILE_SIZE))
            return { isSuccess: false, errorMessage: 'file_too_big' };
        return { isSuccess: true };
    }
};

export const fileFieldValidation = {  
    fileRecord: {
        privateFileName: (value: string) => basicValidation.isValidFileName(value, 128),
        publicFileName: (value: string) => basicValidation.isValidFileName(value, 256)
    },

    externalFile: {
        container: (value: string) => validateStorageContainer(value),
        fileIdentifier: (value: string) => basicValidation.isValidFileName(value, 128)
    },
};

function validateStorageContainer(value:string):boolean
{
    return typeof value === 'string'
            && value !== null
            && value !== undefined
            && new RegExp("^[a-z]{1}[a-z0-9-]{1,30}[a-z0-9]{1}$").test(value);
}